import React from 'react';
import {ListFairProduct} from './sub-view/fair';
import {BusinessLayout} from 'components/layouts/business';

class MyBusinessListFairProduct extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <BusinessLayout active='business-fair'>
        <ListFairProduct/>
      </BusinessLayout>
    );
  }
}

export default MyBusinessListFairProduct;



// WEBPACK FOOTER //
// ./components/my-business/MyBusinessListFairProduct.jsx